import { Link } from "react-router-dom";

export default function Legal({ title }) {
  return (
    <main data-testid="legal-page" className="mx-auto max-w-3xl px-6 pb-32 pt-40">
      <h1 className="font-display text-6xl">{title}</h1>
      <p className="mt-8 text-[#c9c6c0]">[Placeholder — paste your {title.toLowerCase()} text here.]</p>
      <Link to="/" data-testid="legal-home-link" className="link-u mt-10 inline-block pb-1 text-sm uppercase tracking-[0.16em]">Back home</Link>
    </main>
  );
}
